module.exports = __webpack_public_path__ + "img/jxjy_05.png";